import type { CSSProperties } from "react";

const asset = (fileName: string) => `/assets/images/${fileName}`;

export const coin = asset("coin.svg");
export const footerBg1 = asset("footer-bg-1.svg");
export const footerBg2 = asset("footer-bg-2.svg");
export const footerBg3 = asset("footer-bg-3.svg");
export const headerBg1 = asset("header-bg-1.svg");
export const headerBg2 = asset("header-bg-2.svg");
export const headerBg3 = asset("header-bg-3.svg");
export const homeDivider = asset("home-divider.svg");
export const landingBoy = asset("landing-boy.png");
export const landingGirl = asset("landing-girl.png");
export const landingTopi = asset("landing-topi.jpeg");
export const productVariantBg = asset("product-variant-bg.svg");
export const success = asset("success.svg");
export const loader = asset("loader.gif");
export const logo = asset("logo.svg");
export const mockupRight = asset("mockup-right.png");
export const profile = asset("profile.svg");
export const wallet = asset("wallet.svg");

export type AssetSrc = string;

export const toAssetSrc = (assetSrc: AssetSrc): string => assetSrc;

const headerFooterBg3Style: CSSProperties = {
  backgroundImage: `url(${headerBg3}), url(${footerBg3})`,
  backgroundPosition: "top, bottom",
  backgroundRepeat: "repeat-x, repeat-x",
};

export const layoutBackgrounds = {
  auth: headerFooterBg3Style,
  home: headerFooterBg3Style,
  landing: headerFooterBg3Style,
  profile: {
    backgroundImage: `url(${headerBg3})`,
    backgroundPosition: "top",
    backgroundRepeat: "repeat-x",
  } satisfies CSSProperties,
  splash: {
    backgroundImage: `url(${headerBg1}), url(${footerBg1})`,
    backgroundPosition: "top, bottom",
    backgroundSize: "contain, contain",
    backgroundRepeat: "no-repeat, no-repeat",
  } satisfies CSSProperties,
  maintenanceMockup: {
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  } satisfies CSSProperties,
};

export const footerBg3Style: CSSProperties = {
  backgroundImage: `url(${footerBg3})`,
  backgroundPosition: "bottom",
  backgroundRepeat: "repeat-x",
};

export const headerBg3Style: CSSProperties = {
  backgroundImage: `url(${headerBg3})`,
  backgroundRepeat: "repeat-x",
};
